/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thin_Weak_Fox_StepInputs */

const en_thin_weak_fox_step = /** @type {(inputs: Thin_Weak_Fox_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribute`)
};

const de_thin_weak_fox_step = /** @type {(inputs: Thin_Weak_Fox_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkmal`)
};

/**
* | output |
* | --- |
* | "Attribute" |
*
* @param {Thin_Weak_Fox_StepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const thin_weak_fox_step = /** @type {((inputs?: Thin_Weak_Fox_StepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thin_Weak_Fox_StepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thin_weak_fox_step(inputs)
	return de_thin_weak_fox_step(inputs)
});